export const Config = {
    board: {
        width: 500,
        height: 500,
    },
    scoreboard: {
        height: 50,
    },
    aim: {
        startSize: 10,
        size: 100,
    },
    gameTime: 20 * 1000,
};

export const max = {
    x: Config.board.width - Config.aim.size,
    y: Config.board.height - Config.aim.size,
}